<template>
  <div class="yx-jxf-page main-layout predicted-item-page">
    <el-card shadow="never" class="box-inner box-bg">
      <c-title slot="header" title="专业调整"></c-title>
      <div class="pb110">
        <div class="div-scroll">
          <c-form
            v-model="handleData"
            ref="cForm"
            :formRules="formRules"
            labelWidth="100px"
            class="add-form"
            :labelPosition="'left'"
          >
            <div class="tips-container">
              <div class="tips">
                <div class="title">
                  <i class="el-icon-info"></i>
                  <span class="tip-content"
                    >每人只有一次调整专业的机会，请慎重填报!</span
                  >
                </div>
              </div>
            </div>
            <el-form-item label="姓名">
              <el-input v-model="studentInfo.studentName" disabled></el-input>
            </el-form-item>
            <el-form-item label="身份证号">
              <el-input v-model="studentInfo.idCard" disabled></el-input>
            </el-form-item>
            <el-form-item label="录取专业">
              <el-input
                v-model="studentInfo.originalMajorName"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="已调整专业" v-if="studentInfo.majorId">
              <el-input v-model="studentInfo.majorName" disabled></el-input>
            </el-form-item>
            <el-form-item label="学生类别">
              <el-input v-model="studentInfo.typeName" disabled></el-input>
            </el-form-item>
            <el-form-item label="学生省份">
              <el-input
                v-model="studentInfo.sourceProvince"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="考生号">
              <el-input v-model="studentInfo.examNumber" disabled></el-input>
            </el-form-item>
            <el-form-item label="高考分数">
              <el-input v-model="studentInfo.examScore" disabled></el-input>
            </el-form-item>
            <el-form-item
              label="拟调配专业"
              v-if="canChange"
              prop="applyMajorId"
            >
              <el-select
                v-model="handleData.applyMajorId"
                filterable
                placeholder="请选择"
                @change="handleApplyMajorChange"
              >
                <el-option
                  v-for="item in majorOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <i
                class="el-icon-document"
                title="申请历史"
                @click="dialogVisible = true"
              ></i>
            </el-form-item>
            <div class="cant" v-if="!canChange && !isLoading">
              您暂不可以申请专业调整！
            </div>
            <!-- 提交按钮在审批中时不出现 -->
            <el-form-item v-if="status != 3" style="text-align: center">
              <el-button
                type="primary"
                @click="submit"
                size="medium"
                :disabled="!canChange"
                >提交</el-button
              >
            </el-form-item>
            <el-form-item v-if="status == 3" style="text-align: center">
              <el-button
                type="warning"
                @click="dialogFormVisible = true"
                size="medium"
                >取消申请</el-button
              >
            </el-form-item>
          </c-form>
        </div>
      </div>
    </el-card>
    <el-dialog
      :close-on-click-modal="false"
      title="申请历史"
      :visible.sync="dialogVisible"
      width="80%"
    >
      <div class="history-container">
        <c-table
          :data="pageData"
          :tableColumns="tableColumns"
          v-loading="pageLoading"
        >
        </c-table>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="取消申请"
      :visible.sync="dialogFormVisible"
    >
      <el-form :model="form" :rules="rules" ref="cForm" label-width="100px">
        <el-form-item label="原因" prop="message">
          <el-input v-model="form.message" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Configs from "./data/changeMajor.js";
import MHandle from "@/mixins/MHandle.js";
import MPage from "@/mixins/MPage.js";
let mHandle = MHandle({
  handleGetPathNoparam: "",
  handleInsertPath: "",
  handleUpdatePath: "",
  handleDownLoadPath: "",
  handleData: {},
});
let mPage = MPage({
  pagePath: "/oa/welcome/exchangeMajor/getHistoryList",
  pageDelPath: "",
  pageDelsPath: "",
  pageParams: {},
});
export default {
  mixins: [mHandle, mPage],
  data() {
    let { formItems, formRules, tableColumns } = Configs(this);
    return {
      formItems,
      formRules,
      tableColumns,
      studentId: "",
      isApply: false, // 是否申请专业调整
      isSubmit: false,
      canChange: false, // 是否可转专业
      forecastLinkId: "", // 预报到事项id
      status: "", // 预报到事项状态
      // 流程状态：1审批中 2已通过 3已拒绝 4已完成 5已取消
      // 0未完成 1已完成 2驳回 3审核中 4审核通过  5已拒绝
      statusList: {
        0: "未完成",
        1: "已完成",
        2: "已拒绝",
        3: "审核中",
        4: "审核通过",
        5: "已拒绝",
      },
      userId: "",
      studentInfo: {},
      applyInfo: {},
      processInfo: [],
      isDisabled: false, // 是否禁用提交按钮
      defaultHandleData: {
        applyMajorId: "",
      },
      majorOptions: [], // 可调配专业列表
      reason: "", // 拒绝原因
      rules: {
        message: [{ required: true, message: "请输入原因", trigger: "blur" }],
      },
      dialogVisible: false, // 申请历史详情弹框
      dialogFormVisible: false, //取消申请的弹框
      form: { message: "" }, // 取消申请的原因
      isLoading: false, // 配合控制不可换专业提示显隐
      type: 0, // 校验学生是否可换专业类型
      isMust: false,
    };
  },
  created() {
    this.SUCCESS_CODE = this.$store.state.dic.SUCCESS_CODE;
    this.handleData = Object.assign({}, this.defaultHandleData);
    this.token = localStorage.getItem("token");
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.studentId = userInfo.number;
    this.userId = userInfo.id;
    this.forecastLinkId = this.$route.params.id;
    this.status = this.$route.params.status;

    this.getStudentInfo(); // 获取学生基本信息
    this.changeCheck(); // 校验是否可调整专业

    if (this.status == 0 || this.status == 5) {
      this.isMust = true;
    }
  },
  mounted() {},
  methods: {
    handleShowConfirmPopup(type) {
      if (this.status == 0 && type != 3) {
        this.$confirm("请确认是否申请专业调整", "请确认", {
          confirmButtonText: "是",
          cancelButtonText: "否",
          type: "warning",
          showClose: false,
          center: true,
          closeOnClickModal: false,
          closeOnPressEscape: false,
        })
          .then(() => {
            console.log("是");
            this.$message.warning("请按要求填写专业调整申请表单并提交！");
          })
          .catch(() => {
            console.log("否");
            this.noApply();
          });
      } else if (this.isMust && type == 3) {
        // 未完成且必须调专业则弹框
        this.$alert("您必须调整专业，请您在可调范围内选择您的专业！", "提示", {
          // confirmButtonText: "是",
          // cancelButtonText: "否",
          type: "warning",
          showClose: false,
          center: true,
          closeOnClickModal: false,
          closeOnPressEscape: false,
        });
      }
    },
    pageGetBeforeFn(data) {
      data.studentId = this.studentId;
    },
    pageGetAfterFn(data) {
      let pageData = {};
      pageData.records = data;
      return pageData;
    },
    // 校验该学生是否可以申请调换专业
    changeCheck() {
      this.isLoading = true;
      this.$http
        .get("/welcome-live/exchange/rule/check")
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            // res.data为空数组可任意调换专业，非空数组根据规则调换专业
            let type = res.data.type;
            this.type = type;
            if (type != 1) {
              this.canChange = true;
              let ruleIds = res.data.ruleIds ? res.data.ruleIds.join() : "";
              this.handleShowConfirmPopup(type);
              this.getMajorList({ ruleIdStr: ruleIds }, type); // 获取可调换专业列表
              this.getApplyInfo(this.userId); // 获取申请信息详情
            } else {
              // res.data为空时不可调换专业
              this.canChange = false;
              this.majorOptions = [];
              if (this.status == 0) {
                this.$alert("按照学校规定，您暂不可以进行专业调整！", "提示", {
                  type: "warning",
                }).then(() => {
                  this.noApply(); // 提交不换专业
                });
              }
            }
          } else {
            // 请求错误时不可调换专业
            this.canChange = false;
            this.majorOptions = [];
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.canChange = false;
          this.majorOptions = [];
        });
    },
    // 获取可以调整的专业列表
    getMajorList(params, type) {
      this.$http
        .get("/welcome-live/exchange/rule/getMajorListByRuleId/" + type, {
          params,
        })
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            let data = res.data;
            this.majorOptions = data.map((item) => {
              return {
                label: item.majorName,
                value: item.majorId,
              };
            });
          } else {
            this.majorOptions = [];
          }
        })
        .catch((err) => {
          this.majorOptions = [];
        });
    },
    // 获取学生基本信息详情
    getStudentInfo() {
      this.$http
        .get("/account/base/student/myInfoByMajor")
        .then((res) => {
          console.log(res);
          if (res.code == this.SUCCESS_CODE) {
            // let studetnType = [
            //   "普通学生",
            //   "体育生",
            //   "单招",
            //   "艺术生",
            //    "技能类",
            // ];
            let data = res.data;
            // data.studetnType = studetnType[Number(data.type)];
            this.studentInfo = data;
          } else {
            this.$message.error(`获取数据失败，${res.msg}`);
          }
        })
        .catch((err) => {
          this.$message.error(`获取数据失败，${err}`);
        });
    },
    // 根据用户id查询调整专业详情
    getApplyInfo(userId) {
      this.$http
        .get("/oa/welcome/exchangeMajor/getByUserId?userId=" + userId)
        .then((res) => {
          this.handleData.applyMajorId = "";
          if (res.code == this.SUCCESS_CODE) {
            if (res.data.length) {
              this.applyInfo = res.data[0];
              this.handleData.applyMajorId = this.applyInfo.applyMajorId;
            } else {
              this.applyInfo = {};
            }
          } else {
            this.$message.error(res.msg);
            this.applyInfo = {};
          }
        })
        .catch((err) => {
          this.$message.error(err);
          this.applyInfo = {};
        });
    },
    submit() {
      this.$refs.cForm.$refs.cForm.validate((valid) => {
        if (valid) {
          if (!this.canChange) {
            return this.$message.error("不可申请调换专业！");
          }

          // 校验原专业和申请调换专业是否相同,如果有调整过专业，则与跳调整过的专业做比较，若未调整过，则和录取专业做比较
          let majorId =
            this.studentInfo.majorId || this.studentInfo.originalMajorId;
          if (this.handleData.applyMajorId == majorId) {
            return this.$message.error("申请调整的专业和原专业不能相同！");
          }

          this.$confirm("请确认无误后提交，是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.apply(); // 申请
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },
    switchChange(value) {
      // console.log(value);
      if (!this.canChange) {
        this.isApply = false;
        this.$message.error("不可调换专业！");
      }
    },

    // 获取审批详情
    getProcessInfo(id) {
      this.$http
        .get("/oa/processInstance/findCommentsByProcessInstanceId/" + id)
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.processInfo = res.data;
            this.reason = res.data[res.data.length - 1].message;
          } else {
            this.processInfo = [];
          }
        })
        .catch((err) => {
          this.processInfo = [];
        });
    },
    // 专业调整申请
    apply() {
      let params = {
        applyMajorId: this.handleData.applyMajorId, // 申请的专业
        createId: this.userId, // 用户id
        originalMajorId:
          this.studentInfo.majorId || this.studentInfo.originalMajorId, // 原始专业
        studentId: this.studentId, // 编号
        forecastLinkId: this.forecastLinkId, // 事项id
      };
      console.log(params);
      this.isDisabled = true;
      this.$http
        .post("/oa/welcome/exchangeMajor/start", params)
        .then((res) => {
          console.log(res);
          if (res.code == this.SUCCESS_CODE) {
            this.$message.success("提交成功");
            this.$router.replace("/welcome/student/predicted");
          } else {
            this.$message.error(res.msg);
          }
          this.isDisabled = false;
        })
        .catch((err) => {
          this.isDisabled = false;
          this.$message.error("提交失败", err);
        });
    },
    // 不申请调换专业
    noApply() {
      let params = {
        forecastLinkId: this.forecastLinkId,
        studentId: this.studentId,
        isOrNot: 0,
        description: "",
      };
      console.log(params);
      this.isDisabled = true;
      this.$http
        .post("/welcome-live/student/forecast/isOrNot", params)
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.$message.success("提交成功");
            this.$router.replace("/welcome/student/predicted");
          } else {
            this.$message.error("提交失败");
          }
          this.isDisabled = false;
        })
        .catch((err) => {
          this.$message.error("提交失败", err);
          this.isDisabled = false;
        });
    },
    // 确认取消申请
    handleConfirm() {
      this.$refs["cForm"].validate((valid) => {
        if (valid) {
          this.cancelApply();
        } else {
          return false;
        }
      });
    },
    // 确认不取消申请
    handleCancel() {
      this.$refs["cForm"].resetFields();
      this.dialogFormVisible = false;
    },
    // 取消专业调整申请
    cancelApply() {
      let params = {
        id: this.applyInfo.id,
        message: this.form.message,
        userId: this.userId,
        type: this.type,
      };
      this.$http
        .post("/oa/welcome/exchangeMajor/cancel", params)
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.$message.success(res.msg);
            this.$router.go(-1);
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error("取消失败！" + err);
        });
    },
    handleApplyMajorChange(val) {
      // console.log(val);
      if (val == "edb5fd79fbe811ebaed16c2b5944622e") {
        this.handleData.applyMajorId = "";
        return this.$alert("该专业只能在第一学期期末申请调整！", "提示", {
          type: "warning",
        }).then(() => {});
      }
    },
  },
};
</script>

<style scoped lang="less">
.add-form {
  width: 50%;
  margin: 0 auto;
  .el-select {
    width: 100%;
  }
  i.el-icon-document {
    position: absolute;
    right: -30px;
    font-size: 22px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }
}
</style>
